import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0daa2997"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buttons" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "{{", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "}}", -1))
const _hoisted_4 = {
  key: 0,
  class: "hint"
}

import {computed, ref} from "vue";
import {VTextarea} from "vuetify/lib/components";
import {useRoute} from "vue-router";
import SelectItems from "@/utils/SelectItems";
import {useStore} from "vuex";
import {Guild} from "@/types/Guild";
import {ListItemSelect} from "@/types/ListItemSelect";
import {TemplateVariable} from "@/types/TemplateVariable";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateInput',
  props: /*#__PURE__*/_mergeModels({
    variables: {},
    color: {},
    counter: {},
    label: {},
    hint: {},
    required: { type: Boolean },
    disabled: { type: Boolean }
  }, {
    "modelValue": {default: ''},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props
const route = useRoute()
const store = useStore()
let template = _useModel<string>(__props, "modelValue")
let textarea = ref<VTextarea | null>(null)
let guild = computed(() => (store.getters.guilds as Array<Guild>).find(g => g.id === route.params.id));
let roles = SelectItems.roles(guild.value!.roles!, false, false)
let channels = SelectItems.channels(guild.value!.channels!, false, false)
let roleSelect = ref(false);
let channelSelect = ref(false);
let variableSelect = ref(false);

if (!template.value) template.value = ''

const variablesList = Object.keys(i18n.global.tm('TemplateInput.variables'))
    .filter(v => props.variables.includes(v as TemplateVariable))

const rules = [
  (template: string) => ((!props.required || template.length > 0) || i18n.global.t('TemplateInput.errors.required')),
  (template: string) => (template.length <= props.counter ||
      i18n.global.t('TemplateInput.errors.invalidLength').replace("[length]", props.counter.toString()))
]

function roleMention(role: ListItemSelect) {
  let pos = textarea.value!.selectionStart
  let len = template.value?.length
  template.value = template.value?.substring(0, pos) + `<@&${role.id}>` + template.value?.substring(pos, len)
  roleSelect.value = false
}

function channelMention(channel: ListItemSelect) {
  let pos = textarea.value!.selectionStart
  let len = template.value?.length
  template.value = template.value?.substring(0, pos) + `<#${channel.id}>` + template.value?.substring(pos, len)
  channelSelect.value = false
}

function variableAdd(variable: string) {
  let pos = textarea.value!.selectionStart
  let len = template.value?.length
  template.value = template.value?.substring(0, pos) + '{{' + variable + '}}' + template.value?.substring(pos, len)
  variableSelect.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        class: "button",
        icon: "",
        variant: "text",
        size: "40",
        disabled: props.disabled
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode("alternate_email")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tooltip, {
            activator: "parent",
            location: "top"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`TemplateInput.tooltips.role`)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_overlay, {
            modelValue: _unref(roleSelect),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(roleSelect) ? (roleSelect).value = $event : roleSelect = $event)),
            activator: "parent",
            scrim: false,
            "location-strategy": "connected",
            "scroll-strategy": "reposition"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, {
                items: _unref(roles),
                "max-height": 300,
                disabled: !_unref(roleSelect),
                "onClick:select": roleMention
              }, null, 8, ["items", "disabled"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_v_btn, {
        class: "button",
        icon: "",
        variant: "text",
        size: "40",
        disabled: props.disabled
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode("tag")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tooltip, {
            activator: "parent",
            location: "top"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`TemplateInput.tooltips.channel`)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_overlay, {
            modelValue: _unref(channelSelect),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(channelSelect) ? (channelSelect).value = $event : channelSelect = $event)),
            activator: "parent",
            scrim: false,
            "location-strategy": "connected",
            "scroll-strategy": "reposition"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, {
                items: _unref(channels),
                "max-height": 300,
                disabled: !_unref(channelSelect),
                "onClick:select": channelMention
              }, null, 8, ["items", "disabled"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_v_btn, {
        class: "button",
        icon: "",
        variant: "text",
        size: "40",
        disabled: props.disabled
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode("data_object")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tooltip, {
            activator: "parent",
            location: "top"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`TemplateInput.tooltips.variable`)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_overlay, {
            modelValue: _unref(variableSelect),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(variableSelect) ? (variableSelect).value = $event : variableSelect = $event)),
            activator: "parent",
            scrim: false,
            "location-strategy": "connected",
            "scroll-strategy": "reposition"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, {
                items: _unref(channels),
                "max-height": 300,
                disabled: !_unref(variableSelect),
                "onClick:select": channelMention
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(variablesList), (name) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createVNode(_component_v_list_subheader, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(`TemplateInput.variables.${name}.name`)), 1)
                        ]),
                        _: 2
                      }, 1024),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm(`TemplateInput.variables.${name}.list`), (variable) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          onClick: ($event: any) => (variableAdd(_ctx.$rt(variable.name)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _hoisted_2,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$rt(variable.name)), 1),
                                _hoisted_3
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_list_item_subtitle, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$rt(variable.description)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 256))
                    ]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["items", "disabled"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_v_btn, {
        class: "button",
        icon: "",
        variant: "text",
        size: "40",
        href: "https://docs.ufobot.ru/templates/usage",
        disabled: props.disabled,
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode("help_outline")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tooltip, {
            activator: "parent",
            location: "top"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`TemplateInput.tooltips.docs`)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    (props.hint)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.hint), 1))
      : _createCommentVNode("", true),
    _createVNode(_unref(VTextarea), {
      modelValue: _unref(template),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(template) ? (template).value = $event : template = $event)),
      ref_key: "textarea",
      ref: textarea,
      class: "template",
      disabled: props.disabled,
      rules: rules,
      color: props.color ?? 'primary',
      counter: props.counter,
      label: props.label ?? _ctx.$t(`TemplateInput.template`)
    }, null, 8, ["modelValue", "disabled", "color", "counter", "label"])
  ]))
}
}

})